import { Configuration, LogLevel, NavigationClient, NavigationOptions, RedirectRequest, SilentRequest } from '@azure/msal-browser'
import { Router } from 'vue-router';

export const ExternalScopes = [process.env.VUE_APP_MSAL_EXTERNAL_SCOPE!]
export const WorkforceScopes = [process.env.VUE_APP_MSAL_WORKFORCE_SCOPE!]

export const msalExternalConfig: Configuration = {
    auth: {
        clientId: process.env.VUE_APP_MSAL_EXTERNAL_CLIENT_ID!,
        authority: process.env.VUE_APP_MSAL_EXTERNAL_AUTHORITY!,
        redirectUri: window.location.origin,
        knownAuthorities: [
            process.env.VUE_APP_MSAL_EXTERNAL_KNOWN_AUTHORITY!
        ]
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false,
            loggerCallback,
        },
    },
};

export const msalWorkforceConfig: Configuration = {
    auth: {
        clientId: process.env.VUE_APP_MSAL_WORKFORCE_CLIENT_ID!,
        authority: process.env.VUE_APP_MSAL_WORKFORCE_AUTHORITY!,
        redirectUri: window.location.origin,
        knownAuthorities: [
            process.env.VUE_APP_MSAL_WORKFORCE_KNOWN_AUTHORITY!
        ]
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false,
            loggerCallback,
        },
    },
};

export const ExternalAudiences = [msalExternalConfig.auth.clientId, ...ExternalScopes]
export const WorkforceAudiences = [msalWorkforceConfig.auth.clientId, ...WorkforceScopes]

function loggerCallback(level: LogLevel, message: string, containsPii: boolean) {
    if (!containsPii) {
        const parts = message.split(' : ') //TODO: when updating msal - will need to remove the split & pop and implement the decoder for the logs
        const text = parts.pop()
        switch (level) {
            case LogLevel.Error:
                return console.error(text)

            case LogLevel.Warning:
                return console.warn(text)

            case LogLevel.Info:
                return console.info(text)

            case LogLevel.Verbose:
                return console.debug(text)

            default:
                return console.trace(text)
        }
    } else {
        console.log(message)
    }
}

export class VueNavigationClient extends NavigationClient {
    private router: Router

    constructor(router: Router) {
        super()
        this.router = router
    }

    /**
     * Only called during redirects
     */
    navigateExternal(url: string, options: NavigationOptions): Promise<boolean> {
        return super.navigateExternal(url, options)
    }

    /**
     * Only called during popup completion
     */
    async navigateInternal(url: string, options: NavigationOptions): Promise<boolean> {
        const path = url.replace(location.origin, '')
        options.noHistory
            ? await this.router.replace(path)
            : await this.router.push(path)
        return true
    }
}